import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'is-delete-dialog',
  templateUrl: './is-delete-dialog.component.html',
  styleUrls: ['./is-delete-dialog.component.scss']
})
export class IsDeleteDialogComponent implements OnInit {

  constructor(
    private _dialog: MatDialogRef<IsDeleteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  public submit(data?: any): void {
    this._dialog.close(data);
  }

  public cancel(data?: any): void {
    this._dialog.close();
  }
}
